import { Box, Container, Link, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { formatRichText } from "../utils/formatRichText";
function formatText(rawText) {
  return formatRichText(rawText).map((paragraph, index) => (
    <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
  ));
}

const Rules = () => {
  
  const { t } = useTranslation();
  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {t('rules')}
      </Typography>

      <Box sx={{ mt: 4 }}>
        {formatText(t('public_rules'))}
      </Box>
    </Container>
  );
};

export default Rules;
